﻿import {currentCulture, DateTime} from "@2d-front-monorepo/core";

export function formatDateTimeShort(date: DateTime): string {
	return currentCulture().formatDateTime(date, "short");
}
